export default {
  baseURL: 'https://api.appun1g45.com/',
  contextApi: 'api-erpunigas',
}
